import { render, staticRenderFns } from "./Percurso.vue?vue&type=template&id=06ebb354&scoped=true&"
import script from "./Percurso.vue?vue&type=script&lang=js&"
export * from "./Percurso.vue?vue&type=script&lang=js&"
import style0 from "./Percurso.vue?vue&type=style&index=0&id=06ebb354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebb354",
  null
  
)

export default component.exports